import React, { useState, useEffect } from "react";
import Slider from "react-slick";
import { Link, useParams } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { getGuestWishlist, saveGuestWishlist, } from "../../utils/guestStorage.js";
import "../Banner.css";
// import Footer from "./Footer";

const PrevArrow = ({ onClick }) => (
  <div className="banner-arrow banner-prev" onClick={onClick}>
    ❮
  </div>
);

const NextArrow = ({ onClick }) => (
  <div className="banner-arrow banner-next" onClick={onClick}>
    ❯
  </div>
);

// ─── Slider Settings ─────────────────────────────────────────
const sliderSettings = {
  dots: true,
  infinite: true,
  speed: 2900,
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 4000,
  arrows: true,
  prevArrow: <PrevArrow />,
  nextArrow: <NextArrow />,
};

const SubCategory  = () => {
  const [allProducts, setAllProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [selectedCategories, setSelectedCategories] = useState([]);
  const [selectedBrands, setSelectedBrands] = useState([]);
  const [selectedColors, setSelectedColors] = useState([]);
  const [discountFilter, setDiscountFilter] = useState(null);
  const [sortOption, setSortOption] = useState("");
  const [priceRange, setPriceRange] = useState(100000);
  const [hoveredItemId, setHoveredItemId] = useState(null);
  const [selectedRatings, setSelectedRatings] = useState([]);
  const [SubCategoryUser, setSubCategoryUser] = useState([]);
  const [categoryMap, setCategoryMap] = useState({});
  const [wishlistIds, setWishlistIds] = useState([]);
  const [bannerData, setBannerData] = useState([]);


  const { id } = useParams();

  // Fetch subcategories
  useEffect(() => {
  const fetchSubCategories = async () => {
    try {

      const formData = new FormData();
      formData.append("category_id", id);

      console.log("CATEGORY REQ ID:", id);

      const response = await axios.post(
        "https://cyberathon.com/multivendor/index.php/Api/Master_controller/get_id_main_subcategory",
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );


      console.log("SUBCATEGORY API RESPONSE:", response.data);

      if (response.data.status && Array.isArray(response.data.data)) {
        setSubCategoryUser(response.data.data);
      } else {
        setSubCategoryUser([]);
      }

    } catch (error) {
      console.log("Error fetching subcategories", error);
      toast.error("Failed to fetch subcategories");
    }
  };

  if (id) fetchSubCategories();
}, [id]);

useEffect(() => {
  const fetchCategories = async () => {
    try {
      const res = await axios.get(
        "https://cyberathon.com/multivendor/index.php/Api/Master_controller/list_main_category"
      );

      if (res.data.success === "1" && Array.isArray(res.data.row)) {
        const map = {};
        res.data.row.forEach((cat) => {
          map[Number(cat.category_id)] = cat.category_name;
        });
        setCategoryMap(map);
      }
    } catch (err) {
      console.error("Failed to load categories", err);
    }
  };

  fetchCategories();
}, []);



  // Fetch products from API
  // Fetch products from API
useEffect(() => {
  const fetchProducts = async () => {
    try {
      setLoading(true);

      const response = await fetch(
        "https://cyberathon.com/multivendor/index.php/Api/Master_controller/list_create_product"
      );

      const data = await response.json();

      if (data.status && Array.isArray(data.data)) {

        // ✅ ADD ADMIN APPROVAL CONDITION HERE
        const approvedProducts = data.data.filter(
          (product) => product.admin_approval === "approval"
        );

        // 🔍 Optional debug
        console.log(
          "APPROVED PRODUCTS:",
          approvedProducts.map(p => ({
            id: p.product_id,
            admin_approval: p.admin_approval,
            category: p.category_id,
          }))
        );

        // ✅ Transform only approved products
        const transformedProducts = approvedProducts.map((product) => ({
          id: product.product_id,
          brand: product.company_name || product.assign_vendor,
          name: product.product_name,
          price: parseFloat(product.current_price),
          oldPrice: parseFloat(product.old_price),
          discount: Math.round(
            ((parseFloat(product.old_price) - parseFloat(product.current_price)) /
              parseFloat(product.old_price)) * 100
          ),

          category: product.category_id,        // MAIN CATEGORY
          subcategory: product.subcategory_id,  // SUB CATEGORY

          color: product.available_colors,
          images: product.multi_image?.length
            ? product.multi_image.map(
                (img) => `https://cyberathon.com/multivendor/${img}`
              )
            : ["img/placeholder.jpg"],

          rating: parseFloat(product.rating) || 0,
          viewers: `${parseFloat(product.rating || 0).toFixed(1)}K`,
          stock: product.status || "Stock In",
        }));

        setAllProducts(transformedProducts);

        // ✅ Set price range safely
        if (transformedProducts.length > 0) {
          const maxPrice = Math.max(
            ...transformedProducts.map((p) => p.price)
          );
          setPriceRange(maxPrice);
        }
      }

      setLoading(false);
    } catch (err) {
      console.error("Error fetching products:", err);
      setError("Failed to load products");
      setLoading(false);
    }
  };

  fetchProducts();
}, []);


  useEffect(() => {
  const userId = localStorage.getItem("user_id");

  // GUEST USER
  if (!userId) {
    const guestWishlist = getGuestWishlist();
    const ids = guestWishlist.map((item) => item.product_id);
    setWishlistIds(ids);
  }
}, []);

useEffect(() => {
  const userId = localStorage.getItem("user_id");

  // 🟡 GUEST USER
  if (!userId) {
    const guestWishlist = getGuestWishlist();
    setWishlistIds(
      guestWishlist.map((i) => String(i.product_id))
    );
    return;
  }

  // 🔵 LOGGED-IN USER
  const fetchWishlist = async () => {
    try {
      const formData = new FormData();
      formData.append("user_id", userId);

      const res = await fetch(
        "https://cyberathon.com/multivendor/index.php/Api/Master_controller/wish_list",
        { method: "POST", body: formData }
      );

      const result = await res.json();

      console.log("🧾 SUBCATEGORY WISHLIST:", result);

      if (result.status && Array.isArray(result.wishlist)) {
        setWishlistIds(
          result.wishlist.map((i) => String(i.product_id))
        );
      }
    } catch (err) {
      console.error("Wishlist fetch error", err);
    }
  };

  fetchWishlist();
}, []);

useEffect(() => {
    const fetchBanners = async () => {
      try {
        const response = await axios.get(
          "https://cyberathon.com/multivendor/index.php/Api/Master_controller/list_banner"
        );
        setBannerData(response.data.data);
      } catch (error) {
        console.error("Failed to fetch banners:", error);
        // Fallback: show at least one slide even if API fails
        setBannerData([{ banner_heading: "Banner" }]);
      }
    };

    fetchBanners();
  }, []);



  const addToWishList = async (item) => {
  const productId = String(item.id);
  const userId = localStorage.getItem("user_id");

  // 🚫 Prevent duplicate
  if (wishlistIds.includes(productId)) return;

  // ================= GUEST USER =================
  if (!userId) {
    const guestWishlist = getGuestWishlist();

    if (guestWishlist.some(p => String(p.product_id) === productId)) return;

    guestWishlist.push({
      product_id: productId,
      name: item.name,
      price: item.price,
      image: item.images[0],
    });

    saveGuestWishlist(guestWishlist);
    setWishlistIds(prev => [...prev, productId]);
    toast.success("Added to wishlist");
    return;
  }

  // ================= LOGGED-IN USER =================
  try {
    const formData = new FormData();
    formData.append("user_id", userId);
    formData.append("product_id", productId);

    const response = await fetch(
      "https://cyberathon.com/multivendor/index.php/Api/Master_controller/add_wish",
      { method: "POST", body: formData }
    );

    const result = await response.json();

    if (result.status === true) {
      setWishlistIds(prev => [...prev, productId]);
      toast.success("Added to wishlist");
    }
  } catch (err) {
    toast.error("Something went wrong");
  }
};





  const settings = {
    dots: true,
    arrows: false,
    infinite: true,
    speed: 500,
    autoplay: true,
    autoplaySpeed: 1000,
    slidesToShow: 1,
    slidesToScroll: 1,
  };

  const handleCheckboxChange = (value, setter, stateArray) => {
    setter(
      stateArray.includes(value)
        ? stateArray.filter((item) => item !== value)
        : [...stateArray, value]
    );
  };

  const handleDiscountFilter = (value) => {
    setDiscountFilter(discountFilter === value ? null : value);
  };

  const handleSortChange = (e) => {
    setSortOption(e.target.value);
  };

  /* ================= CATEGORY-WISE FILTER (MAIN FIX) ================= */
  const categoryWiseProducts = allProducts.filter(
    (item) => String(item.category) === String(id)
  );

  /* ================= FILTER DATA ================= */
  const uniqueCategories = [
  ...new Set(categoryWiseProducts.map((p) => Number(p.category))),
];

  const uniqueBrands = [
    ...new Set(categoryWiseProducts.map((p) => p.brand).filter(Boolean)),
  ];
  const uniqueColors = [
    ...new Set(categoryWiseProducts.map((p) => p.color).filter(Boolean)),
  ];

  const filteredProducts = categoryWiseProducts
    .filter((item) =>
      selectedCategories.length > 0
        ? selectedCategories.includes(item.category)
        : true
    )
    .filter((item) =>
      selectedBrands.length > 0 ? selectedBrands.includes(item.brand) : true
    )
    .filter((item) =>
      selectedColors.length > 0 ? selectedColors.includes(item.color) : true
    )
    .filter((item) =>
      selectedRatings.length > 0
        ? selectedRatings.some((rating) => item.rating >= rating)
        : true
    )
    .filter((item) => item.price <= priceRange)
    .filter((item) => (discountFilter ? item.discount >= discountFilter : true))
    .sort((a, b) => {
      if (sortOption === "1") return b.price - a.price;
      if (sortOption === "2") return a.price - b.price;
      if (sortOption === "3") return b.discount - a.discount;
      return 0;
    });

  // Split subcategories into slides (12 items = 2 rows of 6)
  const chunkSize = 12;
  const slides = [];
  for (let i = 0; i < SubCategoryUser.length; i += chunkSize) {
    slides.push(SubCategoryUser.slice(i, i + chunkSize));
  }

  if (loading) {
  return (
    <div className="container" style={{ marginTop: "115px" }}>
      
      {/* Banner Skeleton */}
      <div className="skeleton-banner mb-4"></div>

      {/* Subcategory Circles Skeleton */}
      <h4 className="fw-bold mb-4">Shop by Sub Categories</h4>
      <div className="d-flex gap-4 mb-4">
        {[...Array(6)].map((_, i) => (
          <div key={i} className="d-flex flex-column align-items-center gap-2">
            <div className="skeleton-circle"></div>
            <div className="skeleton-label"></div>
          </div>
        ))}
      </div>

      {/* Products + Filters Skeleton */}
      <div className="row">
        <div className="col-lg-2 col-md-3">
          <div className="d-flex flex-column gap-2">
            {[...Array(8)].map((_, i) => (
              <div key={i} className="skeleton-line" style={{ width: `${60 + Math.random()*30}%` }}></div>
            ))}
          </div>
        </div>
        <div className="col-lg-10 col-md-9">
          <div className="row">
            {[...Array(8)].map((_, i) => (
              <div key={i} className="col-lg-3 col-md-4 col-sm-6 mb-4">
                <div className="skeleton-product-img"></div>
                <div className="skeleton-line mt-2" style={{ width: "50%" }}></div>
                <div className="skeleton-line mt-1" style={{ width: "80%" }}></div>
                <div className="skeleton-line mt-1" style={{ width: "60%" }}></div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

  if (error) {
    return (
      <div className="content container-fluid">
        <div style={{ textAlign: "center", padding: "50px", color: "red" }}>
          <p>{error}</p>
        </div>
      </div>
    );
  }

  return (
    <div>
      {/* Subcategories Section */}
      {SubCategoryUser.length > 0 && (
        <div className="container" style={{ marginTop: "115px" }}>
          <div className="banner mb-4">
      <Slider {...sliderSettings}>
        {bannerData.map((banner, index) => (
          <div key={index} className="banner-slide-wrapper">

            {/* Banner Image */}
            <img
            src={`https://cyberathon.com/multivendor/${banner.banner_image}`}
              // src={"../img/1766055277_banner_main.png"}
              alt={banner.banner_heading || "Banner"}
              className="banner-img"
            />

            {/* Overlay Text — Left Side */}
            <div className="banner-overlay-content">
              <h1 className="banner-title">
                Curated Picks for <br></br>Your Lifestyle
              </h1>
              <p className="banner-subtext">
                Not everything. Only what matters.
              </p>
              <a href="#" className="banner-cta">
                Explore Now
              </a>
            </div>

          </div>
        ))}
      </Slider>
    </div>

          <h4 className="fw-bold mb-4">Shop by Sub Categories</h4>

          <div id="categoryCarousel" className="carousel slide" data-bs-ride="carousel">
            <div className="carousel-inner">
              {slides.map((slide, slideIndex) => (
                <div
                  key={slideIndex}
                  className={`carousel-item ${slideIndex === 0 ? "active" : ""}`}
                >
                  <div className="row text-center gy-4">
                    {slide.map((item, index) => (
                      <div
                        key={index}
                        className="col-6 col-sm-4 col-md-3 col-lg-2 d-flex flex-column align-items-center"
                      >
                        <div
                          className="bg-light rounded-circle d-flex justify-content-center align-items-center"
                          style={{
                            width: "120px",
                            height: "120px",
                            overflow: "hidden",
                          }}
                        >
                          <Link
  to={`/products?category=${item.category_id}&subcategory=${item.subcategory_id}`}
  className="shop-now"
>
                          <img
                            src={
                              item.image
                                ? `https://cyberathon.com/multivendor/${item.image}`
                                : "/img/placeholder.jpg"
                            }
                            alt={item.subcategory_name}
                            className="img-fluid"
                            style={{ objectFit: "contain" }}
                          />
                          </Link>
                        </div>
                        <p className="mt-2 mb-0 fw-semibold">
                          {item.subcategory_name}
                        </p>
                      </div>
                    ))}
                  </div>
                </div>
              ))}
            </div>

            <button
              className="carousel-control-prev"
              type="button"
              data-bs-target="#categoryCarousel"
              data-bs-slide="prev"
            >
              <span className="carousel-control-prev-icon bg-primary rounded-circle p-3"></span>
              <span className="visually-hidden">Previous</span>
            </button>

            <button
              className="carousel-control-next"
              type="button"
              data-bs-target="#categoryCarousel"
              data-bs-slide="next"
            >
              <span className="carousel-control-next-icon bg-primary rounded-circle p-3"></span>
              <span className="visually-hidden">Next</span>
            </button>
          </div>
        </div>
      )}

      {/* Products Section */}
      <div className="content container-fluid">
        <div className="midsize">
          Home / <span>Products</span>
        </div>
        <div className="midsizeplus">
          Products <span> - {filteredProducts.length} items</span>
        </div>

        <div className="right sort">
          <select name="type" onChange={handleSortChange}>
            <option value="">Sort By</option>
            <option value="1">Price : High to Low</option>
            <option value="2">Price : Low to High</option>
            <option value="3">Best Discount</option>
          </select>
        </div>

        <div className="row">
          {/* Left Filters */}
          <div className="col-lg-2 col-md-3 col-sm-12 filter-left">
            <div className="filter-heading">FILTERS</div>
            <div className="filters">
              <div className="filter-categories">
  <p>Categories</p>
  {uniqueCategories.map((catId) => (
    <div key={catId}>
      <input
        type="checkbox"
        checked={selectedCategories.includes(catId)}
        onChange={() =>
          handleCheckboxChange(
            catId,
            setSelectedCategories,
            selectedCategories
          )
        }
      />
      <label>{categoryMap[catId] || `Category ${catId}`}</label>
    </div>
  ))}
</div>


              <div className="filter-categories">
                <p>Brand</p>
                {uniqueBrands.map((brand) => (
                  <div key={brand}>
                    <input
                      type="checkbox"
                      onChange={() =>
                        handleCheckboxChange(
                          brand,
                          setSelectedBrands,
                          selectedBrands
                        )
                      }
                    />
                    <label>{brand}</label>
                  </div>
                ))}
              </div>

              <div className="filter-categories">
                <p>Price Range</p>
                <input
                  type="range"
                  min={0}
                  max={100000}
                  value={priceRange}
                  onChange={(e) => setPriceRange(e.target.value)}
                />
                <p>Under ₹{priceRange}</p>
              </div>

              <div className="filter-categories">
                <p>Rating</p>
                {["4", "3", "2"].map((rating) => (
                  <div key={rating}>
                    <input
                      type="checkbox"
                      onChange={() =>
                        handleCheckboxChange(
                          rating,
                          setSelectedRatings,
                          selectedRatings
                        )
                      }
                    />
                    <label>{rating} ★ & above</label>
                  </div>
                ))}
              </div>

              {/* <div className="filter-categories">
                <p>Color</p>
                {uniqueColors.map((color) => (
                  <div key={color}>
                    <input
                      type="checkbox"
                      onChange={() =>
                        handleCheckboxChange(
                          color,
                          setSelectedColors,
                          selectedColors
                        )
                      }
                    />
                    <label>
                      <span className={`color-set-${color}`}></span>{" "}
                      {color.charAt(0).toUpperCase() + color.slice(1)}
                    </label>
                  </div>
                ))}
              </div> */}

              <div className="filter-categories">
                <p>Discount</p>
                {[10, 40, 60, 80].map((val) => (
                  <div key={val}>
                    <input
                      type="checkbox"
                      checked={discountFilter === val}
                      onChange={() => handleDiscountFilter(val)}
                    />
                    <label>{val}% and Above</label>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Right Products */}
          <div className="col-lg-10 col-md-9 col-sm-12 products-right">
            <div className="row">
              {filteredProducts.map((item) => (
                <div
                  key={item.id}
                  className="col-6 col-lg-3 col-md-4 col-sm-6 product-list"
                  onMouseEnter={() => setHoveredItemId(item.id)}
                  onMouseLeave={() => setHoveredItemId(null)}
                  style={{ position: "relative" }}
                >
                  <Link to={`/model/${item.id}`} className="product">
                    <div className="image-container">
                      {hoveredItemId === item.id && item.images.length > 1 ? (
                        <Slider {...settings}>
                          {item.images.map((img, idx) => (
                            <img key={idx} src={img} alt={`slide-${idx}`} />
                          ))}
                        </Slider>
                      ) : (
                        <div className="product-img">
                          <img src={item.images[0]} alt={item.name} />
                          <div className="product-rating">
                            <p>
                              {item.rating} <i className="fa-solid fa-star"></i> |{" "}
                              {item.viewers}
                            </p>
                          </div>
                        </div>
                      )}
                    </div>

                    {hoveredItemId === item.id && (
                        <div className="wishlist">
                          <button
                            type="button"
                            onClick={(e) => {
                              e.preventDefault();
                              e.stopPropagation();
                              addToWishList(item);
                            }}
                          >
                            <i
                              className={
                                wishlistIds.includes(String(item.id))
                                  ? "fa-solid fa-heart text-danger"
                                  : "fa-regular fa-heart"
                              }
                            ></i>
                            Wishlist
                          </button>
                        </div>
                      )}



                    <div className="product-detail">
                      <div className="stock-availability d-none d-md-block">{item.stock}</div>
                      <div className="brand d-none d-md-block">{item.brand}</div>
                      <div className="name">{item.name}</div>
                      <div className="price">
                        ₹{item.price}
                        <span className="line-through"> ₹{item.oldPrice}</span>
                        <span className="discount"> ({item.discount}% OFF)</span>
                      </div>
                    </div>
                  </Link>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
      {/* <Footer /> */}
    </div>
  );
};

export default SubCategory;


// import React, { useEffect, useState } from "react";
// import axios from "axios";
// import { useParams } from "react-router-dom";
// import { toast } from "react-toastify";

// const SubCategory = () => {
//   const [SubCategoryUser, setSubCategoryUser] = useState([]);
//   const { id } = useParams(); 
//   console.log("CATEGORY ID:", id);


//   useEffect(() => {
//     const fetchSubCategories = async () => {
//       try {
//         const response = await axios.post(
//           "https://cyberathon.com/multivendor/index.php/Api/Master_controller/get_id_main_subcategory",
//           { category_id: id }
//         );
//         console.log("API RESPONSE:", response.data);


//         if (response.data.status) {
//           setSubCategoryUser(response.data.subcategories);
//         } else {
//           setSubCategoryUser([]);
//         }
//       } catch (error) {
//         console.log("Error fetching subcategories", error);
//         toast.error("Failed to fetch subcategories");
//       }
//     };

//     fetchSubCategories();
//   }, [id]);

//   // split into slides (12 items = 2 rows of 6)
//   const chunkSize = 12;
//   const slides = [];
//   for (let i = 0; i < SubCategoryUser.length; i += chunkSize) {
//     slides.push(SubCategoryUser.slice(i, i + chunkSize));
//   }

//   return (
//     <div className="container" style={{marginTop:"115px"}}>
//       <h4 className="fw-bold mb-4">Shop by Sub Categories</h4>

//       {slides.length === 0 ? (
//         <p>No subcategories available</p>
//       ) : (
//         <div id="categoryCarousel" className="carousel slide" data-bs-ride="carousel">
//           <div className="carousel-inner">
//             {slides.map((slide, slideIndex) => (
//               <div
//                 key={slideIndex}
//                 className={`carousel-item ${slideIndex === 0 ? "active" : ""}`}
//               >
//                 <div className="row text-center gy-4">
//                   {slide.map((item, index) => (
//                     <div
//                       key={index}
//                       className="col-6 col-sm-4 col-md-3 col-lg-2 d-flex flex-column align-items-center"
//                     >
//                       <div
//   className="bg-light rounded-circle d-flex justify-content-center align-items-center"
//   style={{
//     width: "120px",
//     height: "120px",
//     overflow: "hidden",
//   }}
// >
//   <img
//     src={`https://cyberathon.com/multivendor/${item.image}`}
//     alt={item.subcategory_name}
//     className="img-fluid"
//     style={{ objectFit: "contain" }}
//   />
// </div>

// <p className="mt-2 mb-0 fw-semibold">
//   {item.subcategory_name}
// </p>
//                     </div>
//                   ))}
//                 </div>
//               </div>
//             ))}
//           </div>

//           <button
//             className="carousel-control-prev"
//             type="button"
//             data-bs-target="#categoryCarousel"
//             data-bs-slide="prev"
//           >
//             <span className="carousel-control-prev-icon bg-primary rounded-circle p-3"></span>
//             <span className="visually-hidden">Previous</span>
//           </button>

//           <button
//             className="carousel-control-next"
//             type="button"
//             data-bs-target="#categoryCarousel"
//             data-bs-slide="next"
//           >
//             <span className="carousel-control-next-icon bg-primary rounded-circle p-3"></span>
//             <span className="visually-hidden">Next</span>
//           </button>
//         </div>
//       )}
//     </div>
//   );
// };

// export default SubCategory;


// import React, { useEffect, useState } from "react";
// import "bootstrap/dist/css/bootstrap.min.css";
// import axios from "axios";
// import { toast } from "react-toastify";
// import { useParams } from "react-router-dom";

// const SubCategory = () => {
//   const [SubCategoryUser, setSubCategoryUser] = useState([]);
//   const { id } = useParams();

//   useEffect(() => {
//     const fetchData = async () => {
//       try {
//         const response = await axios.get(
//           "https://cyberathon.com/multivendor/index.php/Api/Master_controller/sub_category_list"
//         );

//         if (response.data && Array.isArray(response.data.result)) {
//           // ✅ FIX: Filter using cat_id (converted to number)
//           const filtered = response.data.result.filter(
//             (item) => item.cat_id === Number(id)
//           );

//           setSubCategoryUser(filtered);
//         } else {
//           setSubCategoryUser([]);
//           console.warn("Unexpected API response structure.");
//         }
//       } catch (error) {
//         console.error("Error fetching data:", error);
//         setSubCategoryUser([]);
//         toast.error("Failed to fetch subcategories.");
//       }
//     };

//     fetchData();
//   }, [id]);

//   // Helper to split array into chunks (12 items = 2 rows of 6)
//   const chunkSize = 12;
//   const slides = [];
//   for (let i = 0; i < SubCategoryUser.length; i += chunkSize) {
//     slides.push(SubCategoryUser.slice(i, i + chunkSize));
//   }

//   return (
//     <div className="container my-4">
//       <h4 className="fw-bold mb-4">Shop by category</h4>

//       <div id="categoryCarousel" className="carousel slide" data-bs-ride="carousel">
//         <div className="carousel-inner">
//           {slides.map((slide, slideIndex) => (
//             <div
//               key={slideIndex}
//               className={`carousel-item ${slideIndex === 0 ? "active" : ""}`}
//             >
//               <div className="row text-center gy-4">
//                 {slide.map((item, index) => (
//                   <div
//                     key={index}
//                     className="col-6 col-sm-4 col-md-3 col-lg-2 d-flex flex-column align-items-center"
//                   >
//                     <div
//                       className="bg-light rounded-circle d-flex justify-content-center align-items-center"
//                       style={{
//                         width: "120px",
//                         height: "120px",
//                         overflow: "hidden",
//                       }}
//                     >
//                       <img
//                         src={`https://cyberathon.com/multivendor/${item.sub_image}`}
//                         alt={item.name}
//                         className="img-fluid"
//                         style={{
//                           maxHeight: "100%",
//                           maxWidth: "100%",
//                           objectFit: "contain",
//                         }}
//                       />
//                     </div>
//                     <p className="mt-2 mb-0 fw-semibold">{item.subcat_name}</p>
//                   </div>
//                 ))}
//               </div>
//             </div>
//           ))}
//         </div>

//         {/* Carousel Controls */}
//         <button
//           className="carousel-control-prev"
//           type="button"
//           data-bs-target="#categoryCarousel"
//           data-bs-slide="prev"
//         >
//           <span className="carousel-control-prev-icon bg-primary rounded-circle p-3" aria-hidden="true"></span>
//           <span className="visually-hidden">Previous</span>
//         </button>
//         <button
//           className="carousel-control-next"
//           type="button"
//           data-bs-target="#categoryCarousel"
//           data-bs-slide="next"
//         >
//           <span className="carousel-control-next-icon bg-primary rounded-circle p-3" aria-hidden="true"></span>
//           <span className="visually-hidden">Next</span>
//         </button>
//       </div>
//     </div>
//   );
// };

// export default SubCategory;